import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

export interface SEOProps {
    title?: string;
    description?: string;
}

export default function SEO({
    title,
    description
}: SEOProps) {
    const { t } = useTranslation();
    const metaTitle = title || t('seo.seo_1');
    const metaDescription = description || t('seo.seo_2');
    return (
        <Helmet htmlAttributes={{ lang: 'pt-BR' }}>
            <meta charSet="utf-8" />
            <meta http-equiv="Content-Language" content="pt-BR" />
            <title>{metaTitle}</title>
            <meta name="description" content={metaDescription} />
            <meta property="og:title" content={metaTitle} />
            <meta property="og:description" content={metaDescription} />
            <meta property="og:locale" content="pt_BR" />
            <meta name='robots' content='index, follow' />
        </Helmet>
    );
}